<template>
  <ThePage :container-classes="'container reviews' + (page.type === 'ranking_index' ? '' : ' container-wide')">
    <component :is="catalogPageType" v-bind="{ 'enable-update': !page.loading }" />
  </ThePage>
</template>

<script setup>
import TheCatalog from '~/components/catalog/TheCatalog';
import CatalogIndex from '~/components/catalog/CatalogIndex';
import pageHead from "~/utils/pageHead";
import imageHelper from '~/utils/image';
import { usePageStore } from "~/stores/page";
import { useRankingStore } from "~/stores/ranking";
import { useRankingSortStore } from "~/stores/rankingSort";


defineI18nRoute({
  paths: {
    es: '/catalogo/[slug]',
    uk: '/catalog/[slug]',
    en: '/catalog/[slug]',
  },
})

const route = useRoute();
const page = usePageStore();
const ranking = useRankingStore();
const rankingSort = useRankingSortStore();

const catalogPageType = computed(() => page.type === 'ranking_index' ? CatalogIndex : TheCatalog);

if (route.query.page) {
  if (route.query.page < 2) {
    navigateTo(route.fullPath.replace(/[?&]page=\d+/, ''), { redirectCode: 301 });
  }

  ranking.setPage(route.query.page);
}

ranking.setUpdateUrl({ url: route.fullPath });

page.loading = true;
ranking.type = 'catalog';

const pageData = ref({});

const params = {
  order_by: rankingSort.selectedSort ||'recommended_rank',
};

if (ranking.listType === 'slim') {
  params.include = 'facts';
  params.exclude = 'colors';
}

if (route.query.page) {
  params.page = route.query.page;
}

try {
  const { data } = await useApiFetch(`/api/category/page/${route.params.slug}`, { params })
  await page.fillRanking(data.value);

  if (page.redirectTo) {
    navigateTo(page.redirectTo, { redirectCode: 301 });
  }

  pageData.value = data.value.page_data;
  provide('pageData', pageData);
} catch (e) {
  console.log(e);
  if (e.type && e.type === 'not_found') {
    throw createError({ statusCode: 404, statusMessage: e.message });
  } else {
    // if (e.type && e.type === 'params_catalog_missing') {
    //   context.$sentry.captureException(e);
    // }
    throw e;
  }
}

if (page.redirectTo) {
  navigateTo(page.redirectTo, { redirectCode: 301 });
}

function buildScripts() {
  const scripts = [];

  if (page.type === 'ranking_index') {
    return scripts;
  }

  const itemListElement = ranking.items.map((item, index) => {
    const deal = item.deals.length ? item.deals[0] : { color: item.default_color };
    return {
      '@type': 'ListItem',
      position: index + 1,
      url: 'https://runrepeat.com' + useLocalePath()(`/${item.slug}`),
      name: item.name,
      image: imageHelper.getImageUrl(deal.color.image, 'lg'),
    };
  });

  if (itemListElement.length > 0) {
    scripts.push({
      body: true,
      hid: 'catalog-page-json-ld',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement,
      }),
      type: 'application/ld+json',
    });
  }

  return scripts;
}

const { query, fullPath } = route;

const isIndexable = Object.keys(query).length === 0 || (Object.keys(query).length === 1 && query.page);

const withMetaLinks = page.meta.canonical.indexOf(fullPath) > 0 && isIndexable;

const head = pageHead.getHead('front-category single-ranking', withMetaLinks, !isIndexable);
head.script.push(...buildScripts());

// Apply "noindex,follow" to paginated calalogs
if (pageHead.isIndexable() && isIndexable && query.page) {
  const noindex = pageHead.getNoindexMeta(true);

  let changed = false;
  head.meta.forEach((tag, i) => {
    if (tag.name === 'robots') {
      head.meta[i].content = noindex.content;
      changed = true;
    }
  });

  if (!changed) {
    head.meta.push(noindex);
  }
}

useHead(head);

onBeforeRouteLeave((to, from, next) => {
  page.expectedType = 'product';
  next();
})
</script>
